import React, { useEffect, useState } from "react";
import requests from "../../requests";
import Axios from "../../axios";
import "./Banner.css";

const Banner = () => {
    const [movie, setMovie] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data } = await Axios.get(requests.getNetflixOriginals);
                setMovie(data.results[Math.ceil(Math.random() * data.results.length)]);
            } catch (error) {
                console.log(error.message);
            }
        };
        fetchData();
    }, []);

    const truncate = (str, n) => {
        return str?.length > n ? str.substr(0, n - 1) + "..." : str;
    };

    return (
        <header className="banner" style={{ backgroundSize: "cover", backgroundPosition: "center top", backgroundImage: `url("https://image.tmdb.org/t/p/original/${movie.backdrop_path}")` }}>
            <div className="banner_contents">
                <h1 className="banner_title">{movie?.title || movie?.name || movie?.original_name}</h1>
                <div className="banner_buttons">
                    <button className="banner_button">Play</button>
                    <button className="banner_button">My List</button>
                </div>
                <h1 className="banner_description">{truncate(movie.overview, 150)}</h1>
            </div>
            <div className="banner_fadeBottom"></div>
        </header>
    );
};

export default Banner;
